module.exports = __webpack_public_path__ + "img/support-grey24.09f0cd10.svg";